import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";
import MaterialTable from "material-table";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Popup from "../../../Base/views/Popup";
import ConfirmationDialog from "../../../Base/views/ConfirmationDialog";
import ContractorConfigPopup from "./ContractorConfigPopup";
import { DeleteContractorAction } from "../../../../../store/Ancillary/Contractor/Action";

const ContractorGrid = () => {
  const dispatch = useDispatch();
  const { contractor_options, isLoading } = useSelector((state) => state?.AtsReducer?.ContractorReducer);

  const [editedRecord, setEditedRecord] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState(null);
  return (
    <Box>
      <MaterialTable
        isLoading={isLoading}
        columns={[
          {
            title: "Contractor Name",
            cellStyle: { padding: "0px 10px" },
            field: "name",
          },
          {
            title: "Address",
            headerStyle: { textAlign: "start", paddingLeft: "2%" },
            cellStyle: { textAlign: "start", padding: "10px 0px 0px 2%" },
            field: "address",
            grouping: false,
          },
          {
            title: "Contact Person",
            headerStyle: { textAlign: "start", paddingLeft: "2%" },
            cellStyle: { textAlign: "start", padding: "10px 0px 0px 2%" },
            field: "contact_person",
            grouping: false,
          },
          {
            title: "Mobile",
            cellStyle: { padding: "0px 10px 0px 15px" },
            field: "mobile_number",
          },
          {
            title: "Email",
            cellStyle: { padding: "0px 10px 0px 15px" },
            field: "email_id",
          },
        ]}
        data={(contractor_options || [])?.filter(el => el?.status === "Active") || []}
        actions={[
          {
            icon: () => <AddIcon />,
            tooltip: "Add Contractor",
            isFreeAction: true,
            onClick: () => {
              setEditedRecord(null);
              setOpenPopup(true);
            },
          },
          {
            icon: () => <EditIcon sx={{ color: "#637381" }} />,
            tooltip: "Edit",
            onClick: (event, rowData) => {
              setEditedRecord(rowData);
              setOpenPopup(true);
            },
          },
          (rowData) => ({
            icon: () => <DeleteIcon sx={{ color: (rowData?.is_default || rowData?.is_utitlised) ? "#bdbdbd" : "#637381" }} />,
            tooltip: rowData?.is_utitlised
                  ? "This contractor is mapped to employees and cannot be deleted"
                  : "Delete",
            onClick: (event, rowData) => setDeleteConfirm(rowData),
            disabled: rowData?.is_utitlised
          })
        ]}
        options={{
          maxBodyHeight: 220,
          rowStyle: { fontSize: "13px" },
          headerStyle: { padding: "0px 10px", fontWeight: "bold" },
          sorting: true,
          search: false,
          searchFieldAlignment: "right",
          searchAutoFocus: true,
          searchFieldVariant: "standard",
          filtering: false,
          paging: false,
          selection: false,
          actionsColumnIndex: -1,
          grouping: false,
          addRowPosition: "first",
        }}
        title=""
      />
      <Popup
        fullWidth={true}
        maxWidth="sm"
        title={editedRecord ? "Edit Contractor" : "Add Contractor"}
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
      >
        <ContractorConfigPopup
          editedRecord={editedRecord}
          setOpenPopup={setOpenPopup}
        />
      </Popup>
      <ConfirmationDialog
        title={"Confirm Delete"}
        content={"Are you sure you want to delete this contractor?"}
        openDialog={Boolean(deleteConfirm)}
        closeDialog={setDeleteConfirm}
        OkButtonText="Yes"
        onSubmit={() => {
              if (deleteConfirm) {
                dispatch(
                  DeleteContractorAction({
                    contractor_id: `{${deleteConfirm?.contractor_id}}`, status: "Inactive"
                  })
                );
              }
              setDeleteConfirm(null);
            }}
      />
    </Box>
  );
};
export default ContractorGrid;
